export const socket_timeout = 8000;
export const debouncer_timeout = 1200;
export const popup_transition_time = 250;
export const element_transition_time = 350;
export const view_type_phone = "phone";
export const view_type_desktop = "desktop";
export const software_version = "v4.11.1";
